import { render, staticRenderFns } from "./OrderCompletePage.vue?vue&type=template&id=03395c1a"
import script from "./OrderCompletePage.vue?vue&type=script&lang=js"
export * from "./OrderCompletePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports